export default __webpack_public_path__ + "static/image042-c1149de021acc97f9bc5993babcb25c9.jpg";